import { getEnvVariable } from "../../modules/environmentalList"

const admindrawer = {
    "type": "drawer",
    "order": 2,
    "key": "drawer",
    "options": {
        "alignitem": "left",
        //"title": "drawer",
        "icon": "alarm",
        "open": true,
        "anchor": 'left',
        "admin": 'Y',
        "items": [
            {
                "type": "tree",
                "title": "Dashboard",
                "materialicon": "dashboard",
                "key": "Dashboard",
                "items": [
                    {
                        "type": "menu",
                        "title": "Notifications",
                        "icon": "notifications_active",
                        "materialicon": "notifications_active",
                        "link": "/notifications",
                        "key": "Notifications",
                        "style": {
                            'color': '#d50000'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Invoice Dashboard",
                        "icon": "assessment",
                        "materialicon": "assessment",
                        "link": "/billingdashboard",
"reloadtab": true,
                        "key": "billingdashboard",
                        "style": {
                            'color': '#c158dc'
                        }
                    },
                ]

            },
            {
                "type": "tree",
                "title": "My Portal",
                "materialicon": "corporate_fare",
                "key": "MyPortal",
                "items": [
                    {
                        "type": "menu",
                        "title": "Search",
                        "icon": "search",
                        "materialicon": "search",
                        "link": "/search",
"reloadtab": true,
                        "key": "Search",
                        "style": {
                            'color': '#61A5DC'
                        }
                    },
                    {
                        "type": "recordmenu",
                        "title": "Records",
                        "materialicon": "source",
                        "key": "Records",
                        "items": [],
                        "lskey": "submodule"
                    },

                    {
                        "type": "menu",
                        "title": "Applicants",
                        "icon": "fa fa-building",
                        "link": "/Administration/companies",
                        "key": "companies",
                        "materialicon": "apartment",
                        "style": {
                            'color': '#ea156d'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "External Contacts",
                        "key": "contacts",
                        "link": "/Administration/globalexternalcontacts",
                        "icon": "fa fa-user-circle-o",
                        "materialicon": "portrait",
                        "style": {
                            'color': '#006064'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Reports",
                        "icon": "fa fa-files-o",
                        "link": getEnvVariable('ReportsUI'),
                        "key": "reports",
                        "newtab": true,
                        "materialicon": "post_add",
                        "style": {
                            'color': '#827717'
                        }
                    },  
                ]

            },


            {
                "type": "tree",
                "title": "Administration",
                "materialicon": "spellcheck",
                "key": "Administration",
                "items": [
                    {
                        "type": "menu",
                        "title": "Users",
                        "icon": "fa fa-users",
                        "link": "/Administration/agencyusers",
                        "key": "AgencyUsers",
                        "materialicon": "person",
                        "style": {
                            'color': '#01579b'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Roles",
                        "key": "roles",
                        "link": "/Administration/roles",
                        "icon": "fa fa-user-circle-o",
                        "materialicon": "manage_accounts",
                        "style": {
                            'color': '#004d40'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Groups",
                        "key": "groups",
                        "link": "/Administration/groups",
                        "icon": "fa fa-users",
                        "materialicon": "device_hub",
                        "style": {
                            'color': '#3f51b5'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Districts",
                        "key": "districts",
                        "link": "/Administration/districts",
                        "icon": "fa fa-map",
                        "materialicon": "map",
                        "style": {
                            'color': '#c158dc'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Parish",
                        "key": "sites",
                        "link": "/Administration/counties",
                        "icon": "fa fa-globe",
                        "materialicon": "settings_system_daydream",
                        "style": {
                            'color': '#006064'
                        }
                    },


                    {
                        "type": "menu",
                        "title": "Email Groups",
                        "key": "groupemails",
                        "link": "/Administration/groupemails",
                        "icon": "fa fa-domain",
                        "materialicon": "email",
                        "style": {
                            'color': '#0c755b'
                        }
                    },
                    
                    {
                        "type": "menu",
                        "title": "Invoice Cycles",
                        "key": "invoicecycles",
                        "link": "/Administration/invoicecycles",
                        "icon": "fa fa-receipt",
                        "materialicon": "attach_money",
                        "style": {
                            'color': '#1bc449'
                        }
                    },

                    // {
                    //     "type": "menu",
                    //     "title": "Consultants",
                    //     "icon": "fa fa-building",
                    //     "link": "/Administration/consultants",
                    //     "key": "consultants",
                    //     "materialicon": "connect_without_contact",
                    //     "style": {
                    //         'color': '#cddc39'
                    //     }
                    // },
                    {
                        "type":"menu",
                        "title": "Authorization",
                        "key": "Authorization",
                        "link": "/Administration/authorizations",
                        "reloadtab": true,
                        "icon": "fa fa-globe",
                        "materialicon": "vpn_key",
                        "style": {
                            'color': '#c158dc'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Registrations",
                        "key": "registrationrequest",
                        "link": "/Administration/registrationrequest",
                        "icon": "fa fa-caret-square-o-right",
                        "materialicon": "how_to_vote",
                        "style": {
                            'color': '#9fa8da'
                        }
                    },
                    {
                        "type": "menu",
                        "title": "Invoice Management",
                        "key": "downloadallinvoices",
                        "link": "/Administration/invoicemanagementtabs",
                        "icon": "fa fa-sync-alt",
                        "materialicon": "request_quote",
                        "style": {
                            'color': '#9fa8da'
                        }
                    },

                ]
            }




        ]
    }
}

export default admindrawer
